"use client";
import { CardTitle, Grid, Table } from '@develos/next-components';
import React from 'react';
import { BinaryRecordDetailsType, VehicleImageEnum, VehicleRecordDetailsType } from '@/types';

type Props = {
  details: VehicleRecordDetailsType;
}

const PhotosContainer = ({ details }: Props) => {
  const getSortedImages = (): BinaryRecordDetailsType[] => {
    const fullVehicle = [...details.binaryRecords].filter(x => x.imageType === VehicleImageEnum.FullVehicle);
    const frontVehicles = [...details.binaryRecords].filter(x => x.imageType === VehicleImageEnum.FrontOfVehicle);
    const plates = [...details.binaryRecords].filter(x => x.imageType === VehicleImageEnum.RegistrationPlate);

    const data: BinaryRecordDetailsType[] = [...fullVehicle, ...frontVehicles, ...plates];
    return data; 
  }

  return (
    <Grid gap={5} columns={1} mdColumns={12} dataTestId='vehicle-details-photos-container'>
      {getSortedImages().map((elem, index) => {
        return (
          <div key={`image-${index}`} className='rm-relative rm-col-span-6'>
            <img className='rm-m-w-full' src={elem.image}/>
          </div> 
        );
      })}
    </Grid>
  );
};

export default PhotosContainer;